import React, { useMemo, useEffect, useState, useCallback, useRef } from 'react';
import StringToReactComponent from 'string-to-react-component';
import toast, { Toaster } from 'react-hot-toast';
import { Navigate, Outlet, Route, Routes, useLocation, useNavigate } from 'react-router';

// Redux & Zustand
import { useDispatch, useSelector } from "react-redux";
import { useAppStore } from "../zustand/useAppStore";
import { useAuthStore } from "../zustand/useAuthStore";

// UI Components & Others
import Modal from "../components/Modal";
import SubHeader from "../components/SubHeader";
import { Table } from './Main Components/Table';
import { MainList } from './Main Components/NestedMenuList';
import { CustomComponent } from "./Main Components/CustomComponent";
import { Icon, addCollection } from '@iconify/react';
import { SystemComponentCache } from '../hooks/useDynamicSystem'; 
import Header from '../components/Header';
import MainTab from '../components/MainTab';
import ERPDashboard from '../components/ERPDashboard';
import HomeNav from '../components/HomeNav';
import SubNav from '../components/SubNav';
import DevPage from './DEV';
import VideoPage from './VideoPage';
import Login from './Login';
import ErrorBoundary from './Main Components/ErrorBoundary';
import { AnimatePresence, motion } from 'framer-motion';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import { CustomInput, selectStyles } from './lib/CustomStyles';
import { format } from "date-fns";
import { ComponentEditorPage } from './EditorPage';
import ERPComponentBuilder from './ERPComponentBuilder';
import { Editor } from '@monaco-editor/react';
import { showConfirm } from '../components/showConfirm';
import { axiosInstance, axiosUpload } from '../services/axios';
import { Grid } from './Main Components/Grid';
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";

import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
  useSortable,
  sortableKeyboardCoordinates,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { ActionButton } from './Main Components/ActionBtn';
import { nArabicWords } from 'narabicwords';
import { useReactToPrint } from 'react-to-print';
import { useDownloadExcel } from 'react-export-table-to-excel';
import ComponentLoader from '../components/ComponentLoader';
import { generateLexoRankMidpoint } from './lib/LexoRankMidpoint';
import ReactCrop, { centerCrop, makeAspectCrop } from 'react-image-crop';
import imageCompression from 'browser-image-compression';
import 'react-image-crop/dist/ReactCrop.css';
const Dynamic = ({ id, asFunction = false, ...passedProps }) => {
  const codeString = SystemComponentCache.get(id);

  // Global tools & hooks bundle
  const systemTools = useMemo(() => ({
   // 🌟 ADD React HERE!
    React, useEffect, useState, useCallback, useMemo, useRef, 
    useDispatch, useSelector, useAppStore, useAuthStore, 
    toast, Toaster, Editor, showConfirm,
   
  // DND
  DndContext,closestCenter,KeyboardSensor,MouseSensor,TouchSensor,useSensor,useSensors, 
  arrayMove,SortableContext,sortableKeyboardCoordinates,verticalListSortingStrategy,useSortable,
  CSS, generateLexoRankMidpoint,

    // ReactCrop & imageCompression
    ReactCrop, centerCrop, makeAspectCrop, imageCompression,
  


    Modal, ActionButton, ComponentLoader, SubHeader, CustomComponent, axiosInstance, axiosUpload,
    Icon, addCollection, Navigate, Route, Routes,
    Header, MainTab, ERPDashboard, HomeNav, SubNav,  
    DevPage, VideoPage, Login, ComponentEditorPage, ERPComponentBuilder,
    DatePicker, Select, CustomInput, selectStyles, format, nArabicWords,
    useDownloadExcel,useReactToPrint,
    useLocation, useNavigate, Outlet,
    motion, AnimatePresence, 
    StringToReactComponent,
    Dynamic: Dynamic 
  }), []);

  const stringData = useMemo(() => {
    return {
      ...systemTools,
      ...passedProps
    };
  }, [systemTools, passedProps.pageData, passedProps.dataType]); 

//console.log(`[Dynamic Debug] ID: "${id}", Found in cache:`, !!codeString);

  if (!codeString) {
    if (asFunction) {
      console.error(`[Dynamic Error] Function script "${id}" not found in cache!`);
      return null;
    }
    return <div className="text-red-500">Component "{id}" not found in system cache.</div>;
  }

  // 🌟 DUAL MODE LOGIC:
  // If `asFunction={true}` is passed, evaluate it as a pure JS function/data script and return its result directly.
  if (asFunction) {
    try {
      // 🌟 Use an IIFE or direct execution string that avoids wrapping syntax issues
      const evaluator = new Function('passedProps', `
        const fn = ${codeString};
        return fn(passedProps);
      `);

      return evaluator(passedProps);
    } catch (error) {
      console.error(`Error evaluating dynamic code as function for "${id}":`, error);
      return null;
    }
  }
  // Otherwise, render it normally as a React Component (UI markup)
  return (
    <ErrorBoundary>
      <StringToReactComponent data={stringData}>
        {codeString}
      </StringToReactComponent>
    </ErrorBoundary>
  );
};

export default Dynamic;